import { Badge } from '@/components/shadcn/badge'
import { cn } from '@/lib/utils'
import type { MdDocumentSummary } from './mdDocumentModel'

export function formatMdDocumentSize(characterCount: number) {
  if (characterCount < 1024) {
    return `${characterCount} characters`
  }
  const kilobytes = characterCount / 1024
  if (kilobytes < 1024) {
    return `${kilobytes.toFixed(1)} KB`
  }
  return `${(kilobytes / 1024).toFixed(2)} MB`
}

export function MdTextMetadataBadges({
  summary,
  className,
}: {
  summary: MdDocumentSummary
  className?: string
}) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <Badge variant="outline">Size: {formatMdDocumentSize(summary.characterCount)}</Badge>
      <Badge variant="outline">Sections: {summary.sectionCount.toLocaleString()}</Badge>
      <Badge variant="outline">Lines: {summary.lineCount.toLocaleString()}</Badge>
    </div>
  )
}

/** Matches {@link ComponentTitle} typography (tile component header). */
export function MdTextDocumentHeading({
  title,
  description,
  summary,
  showTitleAndDescription = true,
  className,
}: {
  title?: string
  description?: string
  summary: MdDocumentSummary
  showTitleAndDescription?: boolean
  className?: string
}) {
  return (
    <div className={cn('flex flex-col gap-y-2', className)}>
      {showTitleAndDescription && title && <h2 className="line-clamp-1 text-lg">{title}</h2>}
      {showTitleAndDescription && description && <p className="text-xs">{description}</p>}
      <MdTextMetadataBadges summary={summary} />
    </div>
  )
}
